import { InputVariant } from "../atoms/Input/Input.types";
// TODO: add unit tests
export const getTextColor = (disabled = false, variant = InputVariant.FILLED) => {
    if (variant === InputVariant.READONLY) {
        return "semantic.text.secondary";
    }
    return disabled ? "semantic.text.tertiary" : "semantic.text.primary";
};
export const getHelpTextIconColor = (disabled = false, variant = InputVariant.FILLED) => {
    if (variant === InputVariant.ERROR) {
        return "semantic.text.error";
    }
    return disabled ? "semantic.icon.disabled" : "semantic.icon.info";
};
export const getHelpTextColor = (variant = InputVariant.FILLED) => {
    if (variant === InputVariant.ERROR) {
        return "semantic.text.error";
    }
    return "semantic.text.tertiary";
};
// TODO: add unit tests
export const getLabelHoverColor = (disabled = false, variant = InputVariant.FILLED) => {
    if (disabled) {
        return "semantic.text.tertiary";
    }
    return variant === InputVariant.READONLY
        ? "semantic.text.secondary"
        : "semantic.interactive.primary";
};
export const transformBoxShadowToDropShadow = (boxShadow) => {
    const boxShadowParts = boxShadow.split(" ");
    const [horizontalOffset, verticalOffset, , spreadRadius, color] = boxShadowParts;
    const dropShadow = `${horizontalOffset} ${verticalOffset} ${spreadRadius} ${color}`;
    return dropShadow;
};
export var KeyboardCodes;
(function (KeyboardCodes) {
    KeyboardCodes["ARROW_UP"] = "ArrowUp";
    KeyboardCodes["ARROW_DOWN"] = "ArrowDown";
    KeyboardCodes["ARROW_LEFT"] = "ArrowLeft";
    KeyboardCodes["ARROW_RIGHT"] = "ArrowRight";
    KeyboardCodes["ENTER"] = "Enter";
    KeyboardCodes["SPACE"] = " ";
    KeyboardCodes["ESCAPE"] = "Escape";
})(KeyboardCodes || (KeyboardCodes = {}));
// CDN DEV: "https://designsystem.visualassets.dev.glb.pluxee.tools/desy-assets/cdn-assets-dev"
export const PROD_CDN_BASE_URL = "https://visualassets.designsystem.pluxee.app/desy-assets/cdn-assets-prd";
//# sourceMappingURL=helpers.js.map